import React from 'react';
import style from '../index.less';

const MessageRedbookPurchaseComment = props => {
  const { data = {} } = props;

  const { comment_id, comment_title, comment_content, content } = data;

  return (
    <div>
      <div className={style['remind-message']} style={{ cursor: 'default' }}>
        <div className={style.text}>
          <div title={comment_title} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            笔记：{comment_title || '--'}
          </div>
          <div title={comment_content} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            评论内容：{comment_content}
          </div>
        </div>
      </div>

      {content}
    </div>
  );
};

export default MessageRedbookPurchaseComment;
